import { j as e } from "./atoms-v218.js";
import { Wrapper as p, AccordionStack as m, AccordionSection as t, RateDescription as y, SummaryWrapper as d, SummaryItem as l, TotalLabel as s, PoliciesText as j } from "./atoms-v21040.js";
import { Text as o } from "./atoms-v243.js";
import { AccordionItem as h } from "./atoms-v21041.js";
import { Accordion as u } from "./atoms-v21042.js";
const S = ({
  colorTheme: c,
  language: n,
  rates: x,
  selectedRateName: a,
  translations: i
}) => /* @__PURE__ */ e.jsx(p, { children: /* @__PURE__ */ e.jsx(u, { children: x.map((r) => /* @__PURE__ */ e.jsx(
  h,
  {
    defaultOpen: r.name === a,
    id: r.name,
    label: r.name,
    children: /* @__PURE__ */ e.jsxs(m, { children: [
      /* @__PURE__ */ e.jsx(t, { $colorTheme: c, children: /* @__PURE__ */ e.jsx(y, { $colorTheme: c, children: r.description }) }),
      /* @__PURE__ */ e.jsx(t, { $colorTheme: c, children: /* @__PURE__ */ e.jsxs(d, { children: [
        /* @__PURE__ */ e.jsxs(l, { children: [
          /* @__PURE__ */ e.jsx(o, { type: "body", variant: "productive", children: i.roomTotalLabel }),
          /* @__PURE__ */ e.jsx(o, { type: "body", variant: "productive", children: r.total_before_tax.toLocaleString(n, {
            currency: r.currency_code,
            style: "currency"
          }) })
        ] }),
        /* @__PURE__ */ e.jsxs(l, { children: [
          /* @__PURE__ */ e.jsx(o, { type: "body", variant: "productive", children: i.taxesAndFeesLabel }),
          /* @__PURE__ */ e.jsx(o, { type: "body", variant: "productive", children: (r.total_after_tax - r.total_before_tax).toLocaleString(n, {
            currency: r.currency_code,
            style: "currency"
          }) })
        ] }),
        /* @__PURE__ */ e.jsxs(l, { children: [
          /* @__PURE__ */ e.jsx(s, { $colorTheme: c, children: i.totalLabel.toUpperCase() }),
          /* @__PURE__ */ e.jsx(s, { $colorTheme: c, children: r.total_after_tax.toLocaleString(n, {
            currency: r.currency_code,
            style: "currency"
          }) })
        ] })
      ] }) }),
      /* @__PURE__ */ e.jsx(t, { $colorTheme: c, children: /* @__PURE__ */ e.jsxs(d, { children: [
        /* @__PURE__ */ e.jsx(o, { type: "body", variant: "productive", children: i.paymentAndCancellationPoliciesLabel }),
        /* @__PURE__ */ e.jsx(j, { $colorTheme: c, children: r.policies })
      ] }) })
    ] })
  },
  r.name
)) }) });
export {
  S as RateDetails
};
